const getToken = () => {
  return JSON.parse(localStorage.getItem("key"));
};

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  authorization: "",
};

//get login user id
const userId = localStorage.getItem('userId');

export const getPermissions = (uid) => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/permission/getPermission`, {
    method: "post",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    body: JSON.stringify({
      user_id: uid
    }),
  }).then((res) => res.json()).then((data) => {
    if (data.status == true) {
      dispatch({
        type: "GET_PERMISSION",
        payload: data?.results[0].connect_permissions,
      });
    }

  });
};

export const set_user_info = (uid) => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/employee/single/profile/${uid}`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },

  }).then((res) => res.json()).then((data) => {
    if (data.status == true) {
      const results = data.data;
      const state = {
        id: results.id,
        fname: results.fname,
        mname: results.mname,
        lname: results.lname,
        img: results.profile_img,
        birth: results.birthday,
        email: results.email,
        contact: results.contact_no,
        dateOfJoining: results.joining_date,
        RMGF: results.RMGF,
        RMGM: results.RMGM,
        RMGL: results.RMGL,
        salutation: results.salutation,
        guardian_name: results.guardian_name,
        gender: results.gender,
        wedding_day: results.wedding_day,
        blood_group: results.blood_group,
        nationality_type: results.nationality_type,
        uid_no: results.uid_no,
        uid_name: results.uid_name,
        pan_no: results.pan_no,
        status: results.status,

        city: results.city,
        state: results.state,
        zipcode: results.zipcode,
        personal_email: results.personal_email,
        comp_id: results.comp_id,
        division: results.division,
        department: results.Roles,
        user_code: results.user_code,
        user_type: results.user_type,
        joining_date: results.joining_date,
        probation_period: results.probation_period,
        Designation: results.Designation,
        role_name: results.role_name,
        dept_name: results.dept_name,



      }
      dispatch({
        type: "SET_USER_INFO",
        payload: state,
      });
    }
  })
};